<script>
  import LibLoader from "./LibLoader.svelte";
  import { createEventDispatcher } from "svelte";
  import * as imagejson from "./logoData.json";
  import { googleAuthCreds, googleAuthToken } from "../stores.js";

  const dispatch = createEventDispatcher();

  let signedIn = isSignedIn();
  let disabled = true;
  let text = "Sign in";
  let image = imagejson.logoData;

  function onLoaded() {
    google.accounts.id.initialize({
      client_id:
        "760914010383-5tivuja0vhdu5jtfv91ecalo6pok7hlp.apps.googleusercontent.com",
      callback: handleCredentialResponse,
      ux_mode: ".\redirect.html",
      prompt_parent_id: "signinBox",
      context: "signin",
      cancel_on_tap_outside: false,
      auto_select: true,
      data_auto_prompt: true,
    });
    disabled = false;
  }

  const handleCredentialResponse = (credsResponse) => {
    console.log(credsResponse);
    console.log(decode(credsResponse["credential"]));
    googleAuthToken.set(credsResponse["credential"]);
    googleAuthCreds.set(JSON.stringify(decode(credsResponse["credential"])));
    let userSignedIn = isSignedIn();
    console.dir(userSignedIn);
  };

  function triggerPrompt() {
    console.dir("Signed in:", signedIn);
    if (!signedIn) {
      google.accounts.id.prompt((notification) => {
        if (notification.isNotDisplayed() || notification.isSkippedMoment()) {
          document.cookie = `g_state=;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT`;
          google.accounts.id.prompt();
          console.log("Prompt cancelled by user");
        }
      });
      signedIn = true;
    } else {
      // I'm logging out by clearing local data
      googleAuthCreds.set(null);
      googleAuthToken.set(null);
      signedIn = false;
      text = "Sign in";
      image = imagejson.logoData;
      dispatch("auth-failed");
    }
  }

  function decode(token) {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      window
        .atob(base64)
        .split("")
        .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join(""),
    );
    return JSON.parse(jsonPayload);
  }

  async function isSignedIn() {
    let fromLocalStorage = $googleAuthCreds;
    if (!fromLocalStorage) return dispatch("auth-failed");
    false;
    if (fromLocalStorage == "null") return dispatch("auth-failed");
    false;
    if (JSON.parse(fromLocalStorage).exp < Date.now() / 1000)
      return dispatch("auth-failed");
    false;
    let result = await valid_token()
      .then((data) => {
        // Use the 'data' received here
        return data;
      })
      .catch((error) => {
        // Handle the error, if any
        console.error(error);
      });
    if (!result) return dispatch("auth-failed");
    false;

    text = "Logout";
    image = JSON.parse(fromLocalStorage).picture;
    dispatch("auth-success");
    return true;
  }

  function valid_token() {
    const url = TT_WEB_API_URL + "/verify_user";

    return fetch(url, {
      method: "GET",
      headers: { Authorization: "Bearer " + $googleAuthToken },
    })
      .then((response) => {
        if (response.status !== 200) {
          throw new Error(response.status);
        } else {
          return true;
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        return false;
      });
  }
</script>

<LibLoader url="https://accounts.google.com/gsi/client" on:loaded={onLoaded} />
<button {disabled} on:click={triggerPrompt}>
  <slot>
    <div class="google-auth">
      <img src={image} alt="Google" />
      <span>{text}</span>
    </div>
  </slot>
</button>
<div id="signinBox"></div>

<svelte:head>
  <script src="https://accounts.google.com/gsi/client" async defer></script>
</svelte:head>

<style>
  button {
    border: 0;
    padding: 0;
  }

  button:disabled .google-auth {
    background-color: grey;
  }

  .google-auth {
    width: 100%;
    background-color: #4285f4;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 2px;
    padding: 5px 1px;
    cursor: pointer;
    width: 220px;
  }

  .google-auth img {
    background: white;
    padding: 4px;
    height: 30px;
    width: 30px;
    border-radius: 2px;
    margin: 4px;
  }

  .google-auth span {
    font-family: Roboto, sans-serif;
    font-size: 14px;
    font-weight: bold;
    padding: 0 12px;
    color: white;
  }
</style>
